import React, { useState } from 'react'
import { Card, ViewHeader, Table, useGet, Help } from '@enkla-gui'
import { icons } from '@config'

export default function Messages() {
  const { data: messages } = useGet({ endpoint: 'api/contact/messages' })
  const [sorting, setSorting] = useState({})

  return (
    <>
      <ViewHeader
        title='Meddelandehistorik'
        subtitle='Översikt'
        icon={icons.email}
      />
      {messages?.length === 0 && (
        <Help type='info' title='Inga hyresgästmeddelanden har skickats ännu'>
          <p>Du kan skicka meddelanden till hyresgäster genom att klicka på "Kontakta hyresgäster" i menyn på antingen objekt, företag, uthyrning eller hyresgäst.</p>
        </Help>
      )}
      <Card>
        <Table
          rows={messages}
          sorting={sorting}
          useSorting={setSorting}
          link='/#!/contact/messages/@{id}'
          empty={{
            text: 'Inga meddelanden har skickats ännu',
            icon: icons.email
          }}
          functions={{
            recipients: (message) => (
              <span class='badge bg-primary'>{message.recipients?.length || 0} mottagare</span>
            )
          }}
          keys={['subject', '_this>function:recipients', 'created_at>date:full']}
          headers={[
            { value: 'Ämne', sortable: false },
            { value: 'Mottagare', sortable: false, class: 'min' },
            { value: 'Skickat', sortable: false, class: 'min'}
          ]}
        />
      </Card>
    </>
  )
}
